<script setup lang="ts">
defineProps({
    formContainerConfig: {
        type: Object,
        required: false,
        default: () => ({}),
        validator: (rawValue) => {
            return rawValue?.sections === undefined || typeof rawValue?.sections === 'number'
        }
    }
})
</script>

<template>
    <div class="form-container" :class="`form-container-${formContainerConfig?.sections}`">
        <slot />
    </div>
</template>

<style lang="scss">
.form-container {
    margin-block-end: px2rem(40);
    display: grid;
    gap: px2rem(30);
    grid-template-columns: 1fr;

    @include bp(medium1) {
        gap: px2rem(40);
    }

    &.form-container-2 {
        @include bp(medium1) {
            grid-template-columns: 1fr 1fr;
        }
    }
}
</style>
